<template>
  <div class="profile-page">
    <van-nav-bar title="我的" />

    <div class="profile-content">
      <!-- 用户卡片 -->
      <div class="user-card">
        <div class="avatar">
          <van-icon name="manager" size="48" color="#4285f4" />
        </div>
        <div class="user-info" v-if="isLoggedIn">
          <div class="user-name">{{ userName }}</div>
          <div class="user-phone">{{ userPhone }}</div>
        </div>
        <div class="user-info" v-else>
          <div class="login-hint" @click="goLogin">点击登录</div>
        </div>
      </div>

      <!-- 菜单列表 -->
    <van-cell-group class="menu-group">
      <van-cell title="我的订单" icon="orders-o" is-link @click="goOrders" />
      <van-cell title="分享中心" icon="share-o" is-link @click="goShareCenter" />
      <van-cell title="我的收藏" icon="star-o" is-link @click="goFavorites" />
      <van-cell title="浏览记录" icon="clock-o" is-link />
      <van-cell title="联系客服" icon="service-o" is-link @click="showContact" />
    </van-cell-group>



    <div class="logout-section" v-if="isLoggedIn">
      <van-button block plain type="danger" @click="doLogout">退出登录</van-button>
    </div>

    <van-action-sheet
      v-model="showContactSheet"
      :actions="contactActions"
      cancel-text="取消"
      close-on-click-action
      @select="onContactSelect"
    />
  </div>
  </div>
</template>

<script>
import stroe from '../store'

const TAB_MINE_INDEX = 2

export default {
  name: 'SaasProfile',
  data() {
    return {
      userName: '',
      userPhone: '',
      isLoggedIn: false,
      showContactSheet: false,
      contactActions: []
    }
  },
  methods: {
    goLogin() {
      this.$router.push('/auth')
    },
    goOrders() {
      if (!this.isLoggedIn) {
        this.goLogin()
        return
      }
      this.$router.push('/my-orders')
    },
    goShareCenter() {
      if (!this.isLoggedIn) {
        this.goLogin()
        return
      }
      this.$router.push('/share-center')
    },
    goFavorites() {
      this.$toast('功能开发中')
    },
    doLogout() {
      this.$dialog.confirm({
        title: '确认退出',
        message: '确定要退出登录吗？'
      }).then(() => {
        this.$common.setAuth('')
        localStorage.removeItem('saas_token')
        localStorage.removeItem('saas_user')
        this.isLoggedIn = false
        this.$router.push('/payment')
      }).catch(() => {})
    },
    loadUserInfo() {
      const token = this.$common.getAuth()
      if (token) {
        this.isLoggedIn = true
        this.userName = this.$common.customStoreGet('user_name') || '已登录用户'
        this.userPhone = this.$common.customStoreGet('user_phone') || ''
      }
    },
    getContactInfo() {
      this.$common.commonHttp('/api/saas_api.php?action=get_contact', {}).then(res => {
        console.log('get_contact res:', res)
        let resData = res.data || {}
        if (resData.status == 1 && resData.data) {
          const actions = []
          const contact = resData.data
          if (contact.contact_phone) {
            actions.push({ name: '电话: ' + contact.contact_phone, value: contact.contact_phone, type: 'phone' })
          }
          if (contact.contact_wechat) {
            actions.push({ name: '微信: ' + contact.contact_wechat, value: contact.contact_wechat, type: 'wechat' })
          }
          if (contact.contact_qq) {
            actions.push({ name: 'QQ: ' + contact.contact_qq, value: contact.contact_qq, type: 'qq' })
          }
          if (contact.contact_email) {
            actions.push({ name: '邮箱: ' + contact.contact_email, value: contact.contact_email, type: 'email' })
          }
          this.contactActions = actions
        }
      }).catch(e => {
        console.error(e)
      })
    },
    showContact() {
      if (this.contactActions.length === 0) {
        this.$toast('暂未配置客服信息')
        return
      }
      this.showContactSheet = true
    },
    onContactSelect(action) {
      if (action.type === 'phone') {
        window.location.href = 'tel:' + action.value
      } else {
        this.copyText(action.value, action.name.split(':')[0])
      }
    },
    copyText(text, typeName) {
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      try {
        document.execCommand('copy')
        this.$toast(typeName + '已复制')
      } catch (e) {
        this.$toast('复制失败，请手动复制')
      }
      document.body.removeChild(input)
    }
  },
  mounted() {
    stroe.commit('setTarbarIndex', TAB_MINE_INDEX)
    this.loadUserInfo()
    this.getContactInfo()
  }
}
</script>

<style scoped>
.profile-page {
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: 60px;
}

.profile-content {
  padding-top: 46px;
}

.user-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 24px 20px;
  background: linear-gradient(135deg, #4285f4, #5b9cf5);
  color: #fff;
}

.avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.user-name {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 4px;
}

.user-phone {
  font-size: 14px;
  opacity: 0.85;
}

.login-hint {
  font-size: 16px;
  cursor: pointer;
  text-decoration: underline;
}

.menu-group {
  margin-top: 12px;
}

.logout-section {
  margin: 24px 16px;
}
</style>
